import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import { TradeReviewReportTable } from "./TradeReviewReportTable";
import { usePageStyles } from "../../../pageStyles";
import { PageComponent } from "../../../../core/navigation/types";
import { PageTitle } from "../../../components/common/PageTitle";
import { TradeReviewReportFilter } from "./TradeReviewReportFilter";
import { DownloadButton, DownloadExcelButton } from "./DownloadButton";

const TradeReviewReport: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="exchTradeReview" />}
              action={<TradeReviewReportActions />}
            />
            <Divider />
            <CardContent>
              <TradeReviewReportTable userAccessRights={userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const TradeReviewReportActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <TradeReviewReportFilter />
    </Grid>
    <Grid item>
      <DownloadButton />
    </Grid>
    <Grid item>
      <DownloadExcelButton />
    </Grid>
  </Grid>
);

export default TradeReviewReport;
